import {
  getTaskChart,
  GetTaskChartData,
  getTaskDetailList,
  GetTaskDetailListData,
  getTaskStd,
  GetTaskBasic,
  getTaskBasic,
  GetTaskLog,
  getTaskLog,
  GetDetailEvent,
  getDetailEvent,
  UpStart,
  upStart,
  GetThrough,
  getThrough,
  GetTaskTrend,
  getTaskTrend,
  getDeptAware,
  GetDept,
  getDeptRate,
} from '@/api/fishing-task-detail'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useGetTaskStd = props => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const { ids, deptName, emailType } = props
  const defaultData = {
    campaign_id: 1,
    campaign_name: '-',
    click: 0,
    create_time: '-',
    end_time: '-',
    open: 0,
    send: 0,
    start_time: '-',
    sub: 0,
  }
  const {
    data,
    runAsync: run,
    loading,
  } = useRequest(
    () =>
      getTaskStd({
        id: id || ids,
        dept_name: deptName,
        email_type: emailType,
      }),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '信息加载失败')
      },
    },
  )

  return [data?.data || defaultData, run, loading] as const
}

interface UseGetTaskTrendProps {
  getTaskChartData: GetTaskTrend
  // send: number
  // open: number
  // click: number
  // sub: number
}
export const useGetTaskTrend = (props: UseGetTaskTrendProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { getTaskChartData } = props
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(() => getTaskTrend(getTaskChartData), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg)
    },
  })
  const res = useMemo(() => {
    const r = {
      time: [],
      send: [],
      see: [],
      open: [],
      click: [],
      sub: [],
      through: [],
      trap: [],
      sum: [],
    }
    if (data?.data?.num) {
      data?.data?.num.forEach(item => {
        if (item.name === '已发送邮件') {
          r.send = item.data
        } else if (item.name === '已打开附件') {
          r.open = item.data
        } else if (item.name === '已查看邮件') {
          r.see = item.data
        } else if (item.name === '已点击链接') {
          r.click = item.data
        } else if (item.name === '已提交信息') {
          r.sub = item.data
        } else if (item.name === '已识破钓鱼') {
          r.through = item.data
        } else if (item.name === '中招趋势') {
          r.trap = item.data
        } else if (item.name === '总人数') {
          r.sum = item.data
        }
      })
      r.time = data.data.xAxis
      return r
    } else {
      return r
    }
  }, [data])
  return [res, loading, run] as const
}
export const useGetTaskChartData = (props: UseGetTaskTrendProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { getTaskChartData } = props
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(() => getTaskChart(getTaskChartData), {
    refreshDeps: [getTaskChartData],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg)
    },
  })
  const res = useMemo(() => {
    const r = {
      time: [],
      barSend: [],
      barSee: [],
      barOpen: [],
      barClick: [],
      barSub: [],
      barThrough: [],
    }
    if (data?.data?.num) {
      data?.data?.num.forEach(item => {
        if (item.name === '已发送邮件') {
          r.barSend = item.data
        } else if (item.name === '已打开附件') {
          r.barOpen = item.data
        } else if (item.name === '已查看邮件') {
          r.barSee = item.data
        } else if (item.name === '已点击链接') {
          r.barClick = item.data
        } else if (item.name === '已提交信息') {
          r.barSub = item.data
        } else if (item.name === '已识破钓鱼') {
          r.barThrough = item.data
        }
      })
      r.time = data.data.xAxis
      return r
    } else {
      return r
    }
  }, [data])
  return [res, loading, run] as const
}

interface UseGetTaskDetailListProps {
  getTaskDetailListParams: GetTaskDetailListData
}
export const useGetTaskDetailList = (props: UseGetTaskDetailListProps) => {
  const { getTaskDetailListParams } = props
  const { data, loading, run } = useRequest(() => getTaskDetailList(getTaskDetailListParams), {
    refreshDeps: [getTaskDetailListParams],
    onError(err: any) {
      Message.error(err?.msg || '列表获取失败')
    },
  })

  return [data?.data || { list: [], total: 0 }, loading, run] as const
}
//任务详情-基础
interface UseGetTaskBasicProps {
  GetTaskBasicParams: GetTaskBasic
}
export const useGetTaskBasic = (props: UseGetTaskBasicProps) => {
  const { GetTaskBasicParams } = props
  const {
    data,
    loading,
    runAsync: run,
  } = useRequest(() => getTaskBasic(GetTaskBasicParams), {
    refreshDeps: [GetTaskBasicParams],
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务详情失败')
    },
  })

  return [data, loading, run] as const
}
//任务详情-发件日志
interface UseGetTaskLogProps {
  GetTaskLogParams: GetTaskLog
}
export const useGetTaskLog = (props: UseGetTaskLogProps) => {
  const { GetTaskLogParams } = props
  const { data, loading, run } = useRequest(() => getTaskLog(GetTaskLogParams), {
    refreshDeps: [GetTaskLogParams],
    onError(err: any) {
      Message.error(err?.msg || '获取任务详情失败')
    },
  })

  return [data?.data || { list: [], total: 0 }, loading, run] as const
}
//任务详情-发件日志

export const useGetDetailEvent = () => {
  const { data, loading, runAsync } = useRequest((datas: GetDetailEvent) => getDetailEvent(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务详情失败')
    },
  })

  return [data?.data || [], loading, runAsync] as const
}

export const useGetTaskOption = () => {
  const { runAsync, loading, data } = useRequest((param: GetDetailEvent) => getDetailEvent(param), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取任务失败')
    },
  })
  return [data?.data || [], runAsync, loading] as const
}
// 修改开始时间
export const useUpStart = () => {
  const { runAsync: run, loading } = useRequest((datas: UpStart) => upStart(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '修改开始时间失败')
    },
  })
  return [run, loading] as const
}
// 提交钓鱼识破
export const useGetThrough = () => {
  const { runAsync: run, loading } = useRequest((data: GetThrough) => getThrough(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg)
    },
  })
  return [run, loading] as const
}
// 获取部门安全意识排名柱状图
export const useGetDeptAware = () => {
  const { runAsync: run, data } = useRequest((datas: GetDept) => getDeptAware(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取部门安全意识排名失败')
    },
  })
  return [run, data?.data?.items || []] as const
}

// 获取部门中招率排名柱状图
export const useGetDeptRate = () => {
  const { runAsync: run, data } = useRequest((datas: GetDept) => getDeptRate(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取部门中招率排名失败')
    },
  })
  return [run, data?.data?.items || []] as const
}
